import script from "./ScreenVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenVideo.vue?vue&type=script&setup=true&lang=js"

import "./ScreenVideo.vue?vue&type=style&index=0&id=e332e1ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e332e1ca"]])

export default __exports__